import request from "@/axios";

/** 查询线上会员权益 */
export const getMemberRightOnlineList = params => {
  return request({
    url: "/lebo-member/web/member/rights-item/page",
    method: "get",
    params
  });
};
/**  //^ ^---------------------------^ ^线上表^ ^---------------------------^ ^ */
/** 分页查询 */
export const getMemberLeftOnlineList = params => {
  return request({
    url: "/lebo-member/web/member/type/page",
    method: "get",
    params
  });
};
/** //^ ^---------------------------^ ^本地表^ ^---------------------------^ ^ */
/** 分页查询 */
export const getMemberTypeLocalList = params => {
  return request({
    url: "/lebo-member/web/member/type-local/page",
    method: "get",
    params
  });
};

/** 新增会员类型的接口 */
export const addMemberTypeLocal = data => {
  return request({
    url: "/lebo-member/web/member/type-local/save",
    method: "post",
    data
  });
};
/**  编辑会员类型的接口 */
export const editMemberTypeLocal = data => {
  return request({
    url: "/lebo-member/web/member/type-local/update",
    method: "post",
    data
  });
};
/** 获取会员详情的接口 */
export const getMemberTypeLocalDetail = id => {
  return request({
    url: `/lebo-member/web/member/type-local/detail`,
    method: "get",
    params: {
      id
    }
  });
};
/** 获取审核快照的接口 */
export const getAuditSnapshot = id => {
  return request({
    url: `/lebo-member/web/member/type-local/snapshot`,
    method: "get",
    params: {
      id
    }
  });
};
/** 提交审核的接口 */
export const submitAudit = id => {
  return request({
    url: `/lebo-member/web/member/type-local/submit`,
    method: "post",
    params: {
      id: id
    }
  });
};
/** 撤销审核的接口 */
export const cancelAudit = id => {
  return request({
    url: `/lebo-member/web/member/type-local/recall`,
    method: "post",
    params: {
      id: id
    }
  });
};
/** 删除会员类型的接口 */
export const deleteMemberTypeLocal = id => {
  return request({
    url: `/lebo-member/web/member/type-local/remove`,
    method: "post",
    params: {
      id: id
    }
  });
};
/** 审核通过会员类型的接口 */
export const passMemberTypeLocal = params => {
  return request({
    url: `/lebo-member/web/member/type-local/pass`,
    method: "post",
    params
  });
};
/** 审核拒绝会员类型的接口 */
export const rejectMemberTypeLocal = params => {
  return request({
    url: `/lebo-member/web/member/type-local/reject`,
    method: "post",
    params
  });
};
/** 获取操作日志的接口 */
export const getLog = params => {
  return request({
    url: `/lebo-member/web/member/operate-log/page`,
    method: "get",
    params
  });
};
//^ ^--------------------------------------数据处理---------------------------------------^ ^
/** 获取业务字典里的限制参数 */
/** 获取限制参数 */
export const getLimitParams = () => {
  return request({
    url: "/lebo-system/dict-biz/list",
    method: "get",
    params: {
      code: "member_limit_params"
    }
  });
};
/** 按客户端获取权益项列表的接口 */
export const getMemberTypeLocalListByClient = () => {
  return request({
    url: "/lebo-member/web/member/rights-item/client-rights",
    method: "get"
  });
};
/** 获取客户端类型 */
export const getClientType = () => {
  return request({
    url: "/lebo-system/dict-biz/list",
    method: "get",
    params: {
      code: "client_types"
    }
  });
};

/** 客户端-权益项二级列表 */
export const getMemberRightLocalList = () => {
  return request({
    url: "/lebo-member/web/member/rights-item/client-rights-dict",
    method: "get"
  });
};
/** 权益项-限制参数字典 */
export const getMemberRightLocalLimitParams = () => {
  return request({
    url: "/lebo-member/web/member/rights-item/rights-limit-dict",
    method: "get"
  });
};
/** 获取会员类型字典 */
export const getMemberTypeLocalDict = () => {
  return request({
    url: "/lebo-member/web/member/type/dict",
    method: "get"
  });
};
/** 获取审核状态字典 */
export const getAuditStatusDict = () => {
  return request({
    url: "/lebo-system/dict-biz/child-list",
    method: "get",
    params: {
      parentId: "1676902270054215682",
      current: 1,
      size: 50
    }
  });
};
/** 获取小屏会员展示场景 */
export const getSmallScene = () => {
  return request({
    url: "/lebo-system/dict-biz/child-list",
    method: "get",
    params: {
      parentId: "1678325586577108994",
      current: 1,
      size: 50
    }
  });
};
/** 获取大屏会员展示场景 */
export const getBigScene = () => {
  return request({
    url: "/lebo-system/dict-biz/child-list",
    method: "get",
    params: {
      parentId: "1678325747420278785",
      current: 1,
      size: 50
    }
  });
};
/** 获取sdk会员展示场景 */
export const getSdkScene = () => {
  return request({
    url: "/lebo-system/dict-biz/child-list",
    method: "get",
    params: {
      parentId: "1678325957835927554",
      current: 1,
      size: 50
    }
  });
};
/** 获取会员类别 */
export const getMemberType = () => {
  return request({
    url: "/lebo-system/dict-biz/child-list",
    method: "get",
    params: {
      parentId: "1676911412416393218",
      current: 1,
      size: 50
    }
  });
};
/** 获取用户身份 */
export const getUserIdentity = () => {
  return request({
    url: "/lebo-system/dict-biz/child-list",
    method: "get",
    params: {
      parentId: "1676913556729147393",
      current: 1,
      size: 50
    }
  });
};

/** 根据UUID查询会员身份，可选携带开始时间，用于时间点快照查询 */
export const getUserMemberType = (uuid, startTime) => {
  const params = { uuid }
  if (startTime) params.startTime = startTime
  return request({
    url: "/lebo-member/web/member/rights-item/user-rights",
    method: "get",
    params
  });
};

/** 查询在售的类型 */
export const getMemberTypeLocalListBySellStatus = (params) => {
  return request({
    url: "/lebo-member/web/member/type-local/getAffectedSaleMemberTypes",
    method: "get",
    params
  });
};
